import React from 'react';
import { createPortal } from 'react-dom';
import { SelectiveExportImportPanel } from './SelectiveExportImportPanel';
import { useEscapeKey } from '@/common/hooks/useEscapeKey';
import { useModalOverlayClick } from '@/common/hooks/useModalOverlayClick';
import './DataBackupsModal.css';

interface DataBackupsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DataBackupsModal: React.FC<DataBackupsModalProps> = ({ isOpen, onClose }) => {
  // Close on escape key
  useEscapeKey(onClose, isOpen);

  // Handle overlay clicks with buffer zone
  const [modalContentRef, handleOverlayClick, handleOverlayMouseDown] = useModalOverlayClick(onClose, 30);

  if (!isOpen) return null;

  const content = (
    <div className="modal-overlay" onMouseDown={handleOverlayMouseDown}
 onClick={handleOverlayClick}>
      <div className="modal-content data-backups-modal" ref={modalContentRef}>
        <div className="modal-body xv-scroll">
          <SelectiveExportImportPanel onClose={onClose} />
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};
